import { DefaultPrivacyLevel } from '@datadog/browser-rum';

import { Environment } from '../app/shared/enums/environment.enum';

import { EnvironmentInterface } from './environments.interface';
import { EnvironmentsShared } from './environments-shared';

export const environment: EnvironmentInterface = {
	apiUrl: 'https://api.sanus.tech',
	apis3rd: EnvironmentsShared.apis3rd,
	datadog: {
		applicationId: 'cf3fd9fa-4aa7-4742-bd30-a175079db294',
		clientToken: 'pubfe892750cbc521c260c48985aef889e8',
		defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
		isEnabled: false,
		service: 'web-sanus',
		sessionReplaySampleRate: 10,
		sessionSampleRate: 100,
		site: 'datadoghq.com',
		trackLongTasks: true,
		trackResources: true,
		trackUserInteractions: true,
	},
	isProduction: true,
	isStaging: false,
	name: Environment.Production,
	sentry: {
		dsn: EnvironmentsShared.sentry.dsn,
		replaysOnErrorSampleRate: 1.0,
		replaysSessionSampleRate: 0.1,
		tracesSampleRate: 0.15,
	},
};
